import Vue from 'vue'
import Element,{ Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Element.Dialog.props.closeOnClickModal.default = false; // 修改 el-dialog 默认点击遮照为不关闭
Element.Tooltip.props.enterable.default = false;   //Tooltip  el-tooltip 默认鼠标不能移入小提示框tooltip中


/***重写element-ui $message 解决消息多次弹出的问题**/
let messageInstance = null;
const overrideMessage = (options) => {
    if(messageInstance) {
        messageInstance.close();
    }
    if (typeof options === "string") {
        options = {
            message: options
        };
    }
    messageInstance = Message(Object.assign({}, options,{showClose: true}));
};
["error","success","info","warning"].forEach(type => {
    overrideMessage[type] = options => {
        if (typeof options === "string") {
            options = {
                message: options
            };
        }
        options.type = type;
        options.showClose = true;
        return overrideMessage(options);
    };
});
/***重写message**/

Vue.use(Element)
Vue.prototype.$message = overrideMessage;
